module.exports = __webpack_public_path__ + "img/969b0e2ce83001649b5a8c7b2362f5d2.png";